import {
  SlRadioButton
} from "./chunk.UQLG3DBF.js";
import {
  radio_button_styles_default
} from "./chunk.RJ3RKQ47.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/radio-button/radio-button.ts
var FadvRadioButton = class extends SlRadioButton {
  constructor() {
    super(...arguments);
    this.outline = false;
    this.isHovered = false;
  }
  get labelType() {
    return `label-${this.size}`;
  }
  updateIcon() {
    var _a, _b;
    if (this.shadowRoot) {
      const prefixSlot = ((_a = this.shadowRoot.querySelector("slot[name='prefix']")) == null ? void 0 : _a.assignedElements()) || [];
      const suffixSlot = ((_b = this.shadowRoot.querySelector("slot[name='suffix']")) == null ? void 0 : _b.assignedElements()) || [];
      [...prefixSlot, ...suffixSlot].forEach((e2) => {
        let icon;
        if (hasTag(e2, "fadv-icon")) {
          icon = e2;
        } else {
          icon = e2.querySelector("fadv-icon");
        }
        if (!icon)
          return;
        icon.foreground = this.isHovered ? void 0 : this.variant;
      });
    }
  }
  handleMouseenter() {
    this.isHovered = true;
    this.updateIcon();
  }
  handleMouseleave() {
    this.isHovered = false;
    this.updateIcon();
  }
  render() {
    return $`<div><input class="hidden-input" type="radio" aria-hidden="true" tabindex="-1" /><span class=${o({
      button: true,
      "button--default": this.variant === "primary",
      "button--primary": this.variant === "primary",
      "button--secondary": this.variant === "secondary",
      "button--tertiary": this.variant === "tertiary",
      "button--success": this.variant === "success",
      "button--neutral": this.variant === "neutral",
      "button--warning": this.variant === "warning",
      "button--danger": this.variant === "danger",
      "button--text": this.variant === "text",
      "button--monochrome": this.variant === "monochrome",
      "button--small": this.size === "small",
      "button--medium": this.size === "medium",
      "button--large": this.size === "large",
      "button--active": this.checked,
      "button--disabled": this.disabled,
      "button--focused": this.hasFocus,
      "button--standard": !this.outline,
      "button--outline": this.outline,
      "button--pill": this.pill,
      "button--has-label": this["hasSlotController"].test("[default]"),
      "button--has-prefix": this["hasSlotController"].test("prefix"),
      "button--has-suffix": this["hasSlotController"].test("suffix"),
      "button--hover": this.isHovered
    })} ><button class="button__interior" ?disabled=${this.disabled} type="button" name=${l(this.name)} value=${l(this.value)} @blur=${this.handleBlur} @focus=${this.handleFocus} @click=${this.handleClick} @mouseenter=${this.handleMouseenter} @mouseleave=${this.handleMouseleave} ><span part="prefix" class="button__prefix"><slot name="prefix"></slot></span><span type="${this.labelType}" class="button__label"><slot></slot></span><span part="suffix" class="button__suffix"><slot name="suffix"></slot></span></button></span></div>`;
  }
};
FadvRadioButton.styles = radio_button_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvRadioButton.prototype, "outline", 2);
__decorateClass([
  t()
], FadvRadioButton.prototype, "isHovered", 2);
FadvRadioButton = __decorateClass([
  n("fadv-radio-button")
], FadvRadioButton);

export {
  FadvRadioButton
};
